import {useAtomValue} from 'jotai';
import {memo, useEffect, useState} from 'react';
import {MarkersLayerProps, UniversityData} from '@/map/@types';
import {useNearbyUniversity} from '@/map/api';
import {nearbyInfoAtom} from '@/map/atom';
import {MARKER_COUNT_LIMIT} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {convertToCoordFromPointCoords} from '@/map/utils';
import {UniversityMarker} from '../../Markers';

const getList = (data?: UniversityData[]) => {
  const draft: UniversityData[] = [];

  if (!data) {
    return draft;
  }

  data.forEach((i: UniversityData) => {
    const index = draft.findIndex(
      (j) => i.name === j.name && i.studentsCount === j.studentsCount
    );

    if (index === -1) {
      const coords = i?.location?.coordinates;
      const point = convertToCoordFromPointCoords(coords);
      const item = {...i};

      if (point) {
        item.position = point;
      }

      draft.push(item);
    }
  });

  return draft;
};

export const UniversityLayer = memo(({map, bounds}: MarkersLayerProps) => {
  const {selected} = useAtomValue(nearbyInfoAtom);
  const isActive = selected.includes(AreaAnalyticsFilter.UNIVERSITY);
  const [list, setList] = useState<UniversityData[]>([]);

  const {data} = useNearbyUniversity(
    isActive && bounds
      ? {
          limit: MARKER_COUNT_LIMIT,
          ...bounds,
        }
      : undefined
  );

  useEffect(() => {
    if (data?.length) {
      setList((prev) => {
        return getList([
          ...prev.filter(
            (i) => i.position && map.getBounds().hasPoint(i.position)
          ),
          ...data.slice(0, MARKER_COUNT_LIMIT),
        ]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!isActive || !list?.length) {
    return null;
  }

  return (
    <>
      {list.map(
        (i, idx) =>
          !!i.position && (
            <UniversityMarker
              key={idx + i.name + i.position.toString()}
              map={map}
              position={i.position}
              item={i}
            />
          )
      )}
    </>
  );
});
